// All backend money values are integer cents.

export const money = (centsVal, opts = {}) => {
  const dollars = (Number(centsVal) || 0) / 100;
  return dollars.toLocaleString('en-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: opts.cents === false ? 0 : 2,
    maximumFractionDigits: opts.cents === false ? 0 : 2,
  });
};

// Compact money for KPI values: $1.2M / $45.3K / $912
export const moneyCompact = (centsVal) => {
  const d = (Number(centsVal) || 0) / 100;
  const abs = Math.abs(d);
  if (abs >= 1_000_000) return `$${(d / 1_000_000).toFixed(2)}M`;
  if (abs >= 10_000) return `$${(d / 1_000).toFixed(1)}K`;
  return money(centsVal, { cents: abs < 100 });
};

export const int = (n) => (Number(n) || 0).toLocaleString('en-CA');

export const pct = (fraction, digits = 1) =>
  `${(fraction * 100).toFixed(digits)}%`;

// Change vs previous value → { pct, dir } or null when not computable
export const delta = (curr, prev) => {
  if (prev === null || prev === undefined || Number(prev) === 0) return null;
  const f = (Number(curr) - Number(prev)) / Math.abs(Number(prev));
  return { f, dir: f > 0.0005 ? 'up' : f < -0.0005 ? 'down' : 'flat' };
};

export const toISODate = (d) => {
  const dt = d instanceof Date ? d : new Date(d);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
};

export const addDays = (isoDate, days) => {
  const d = new Date(isoDate + 'T12:00:00');
  d.setDate(d.getDate() + days);
  return toISODate(d);
};

export const niceDate = (isoDate) => {
  if (!isoDate) return '';
  const d = new Date(isoDate + 'T12:00:00');
  return d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Export an array of row objects as a CSV download.
export const downloadCsv = (filename, columns, rows) => {
  const esc = (v) => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [
    columns.map(c => esc(c.label)).join(','),
    ...rows.map(r => columns.map(c => esc(typeof c.csv === 'function' ? c.csv(r) : r[c.key])).join(',')),
  ];
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
};
